import React from 'react'
import { Link } from 'react-router-dom'

export default function CardProject({ id, img, title, url_project, url_repo }) {
    return (
        <div className="project animate__animated animate__flipInX">
            <img src={img} alt={title} />
            <div className="description__project">
                <h4 className="project__title">{title}</h4>

                <a target="_blank" rel="noreferrer" className="ver_page" href={url_project}>Ver sitio</a>
                <a target="_blank" rel="noreferrer" href={url_repo} className="button_github"><i className="fab fa-github"></i></a>
                <Link className="ver_page_mas" to={`./portafolio/${id}`}>
                            Mas...
                </Link>
            </div>

        </div>
    )
}
